import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Modal,
} from "@mui/material";

import { useGetProductQuery } from "../../../api/productsApi";
import ProductDetailCard from "../../cards/product/ProductDetailCard";
import ProductPriceCard from "../../cards/product/ProductPriceCard";
import ProductStockCard from "../../cards/product/ProductStockCard";

interface Props {
  id: string;
  openModal: boolean;
  toggle: () => void;
}

const ProductDetailModal = (props: Props): JSX.Element => {
  const { data, isError, isFetching, isLoading } = useGetProductQuery(props.id, {
    skip: !props.id,
  });

  const isBusy = isFetching || isLoading;

  return (
    <Modal
      open={props.openModal}
      onClose={props.toggle}
      aria-label="Detalhes do produto"
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 0,
        },
      }}
      sx={{
        overflow: "hidden",
      }}
    >
      <Box
        onClick={props.toggle}
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: { xs: "flex-start", sm: "center" },
          overflowY: "auto",
          py: { xs: 2, sm: 3 },
        }}
      >
        <Card
          onClick={(event) => event.stopPropagation()}
          sx={{
            position: "relative",
            zIndex: 1,
            flexShrink: 0,
            width: {
              md: "40%",
              sm: "70%",
              xs: "calc(100% - 32px)",
            },
            maxHeight: "calc(100vh - 32px)",
            overflowY: "auto",
            backgroundColor: "#fafafa",
            opacity: 1,
            "@supports (height: 100dvh)": {
              maxHeight: "calc(100dvh - 32px)",
            },
          }}
        >
          <CardContent>
            {isBusy && (
              <Box
                sx={{
                  minHeight: 180,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress color="success" size={56} />
              </Box>
            )}

            {!isBusy && (isError || !data) && (
              <Alert severity="error">
                Não foi possível carregar os detalhes do produto.
              </Alert>
            )}

            {!isBusy && data && (
              <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                  <ProductDetailCard
                    id={data.codigo}
                    name={data.nome}
                    unit={data.unidadeMedida}
                    width={data.largura}
                    grammage={data.gramatura}
                  />
                </Grid>
                {data.precoProduto && data.precoProduto.length > 0 && (
                  <Grid item xs={12} md={12}>
                    <ProductPriceCard
                      precoproduto={data.precoProduto}
                      percentIpi={data.percentualIpi}
                    />
                  </Grid>
                )}
                {data.saldoProduto && data.saldoProduto.length > 0 && (
                  <Grid item xs={12} md={12}>
                    <ProductStockCard saldoproduto={data.saldoProduto} />
                  </Grid>
                )}
              </Grid>
            )}
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

export default ProductDetailModal;
